import { ca } from '@cian/analytics';

export const trackDropdownLinkClick = (label: string, event: string = 'event') => ca(event, {
  name: 'oldevent',
  category: 'other_page',
  action: 'top_menu',
  label,
});



// WEBPACK FOOTER //
// ./src/bundles/header/components/dropdown_menu/tracking.ts